import { castStoneServiceStores } from "@intrasync/cast-stone";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Service stores from `@intrasync/cast-stone`. ServiceStore registration is
 * first-wins/idempotent (see StoreRegistry.registerServiceStore), so any name
 * another module already registers with richer config would need filtering out
 * here. Every name this package declares is `cast-stone-*`-prefixed, and the
 * collision check against src/serviceStores/ found none — no filter needed.
 */
export const castStoneStores: ServiceStoreConfig[] =
  castStoneServiceStores as unknown as ServiceStoreConfig[];
